import React from 'react';
import { APP_NAME } from '../../../config/consts';

import style from './index.scss';

const { BUILD_VERSION } = process.env;

const showAppVersion = localStorage.getItem(`${APP_NAME.toUpperCase()}_SHOW_VERSION`);

const Version = () =>
    showAppVersion ? (
        <div className={style.wrapper}>
            <div className="container">
                <div className={style.content}>Version: {BUILD_VERSION}</div>
            </div>
        </div>
    ) : null;

export default Version;
